import classNames from "classnames";
import { useContext, useEffect, useState } from "react";

import Dropdown from "src/app/components/dropdown/Dropdown";
import { TARGET_GROUPS } from "src/app/modules/auth/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ModalContext } from "src/contexts/ModalContext";
import { ApiResult } from "src/core/helpers/api/ApiResult";
import { AccountsService } from "src/core/services/auth";
import { IAuth } from "src/types/global";

import authCSS from "../Auth.module.css";

const ConfirmTargetGroupForm = ({
  userData,
  onConfirmTargetGroup,
}: {
  userData: IAuth | undefined | null;
  onConfirmTargetGroup: (success: boolean) => void;
}) => {
  const [selectedTargetGroup, setSelectedTargetGroup] = useState(0);
  const [formErrors, setFormErrors] = useState<any>({});

  const authData = useContext(AuthContext);
  const modalData = useContext(ModalContext);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    const targetGroupValue = TARGET_GROUPS.getText(selectedTargetGroup);
    const errors = validate();
    setFormErrors(errors);
    if (errors && Object.keys(errors).length === 0 && Object.getPrototypeOf(errors) === Object.prototype) {
      AccountsService.updateTargetGroup(userData!.id!, targetGroupValue)
        .then((response) => {
          onConfirmTargetGroup(true);
          authData?.updateProfileData(response);
          modalData?.triggerSuccess({
            title: "Uspješno ažuriranje",
            message: "Uspješno ste ažurirali ciljnu skupinu",
          });
        })
        .catch((e: ApiResult) => {
          onConfirmTargetGroup(false);
          modalData?.triggerError(e);
        });
    }
  };

  const validate = () => {
    const errors: any = {};
    if (selectedTargetGroup === 0) {
      errors.targetGroup = "* Potrebno je odabrati ciljnu skupinu";
    }
    return errors;
  };

  const handleSelectChange = (selectedTargetValue: number) => {
    setSelectedTargetGroup(selectedTargetValue);
  };

  useEffect(() => {
    for (const property in formErrors) {
      if (formErrors[property] && formErrors[property].length > 0) {
        const newErrors = validate();
        setFormErrors((formErrors: any) => {
          return {
            ...formErrors,
            [property]: newErrors[property],
          };
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTargetGroup]);

  return (
    <div className="u-flex u-flex-column u-flex-items-center">
      <h3 className="u-t-primary-dark u-t-uppercase u-m0 u-pt10px u-pb10px">Dopuna podataka</h3>
      <p className="u-t-f16p u-t-w400 u-m0 u-pb10px u-t-lh16">U svrhu dopune korisničkih podataka, molimo vas da odaberete ciljnu skupinu.</p>
      <form onSubmit={handleSubmit} className={classNames("u-col-xs-12", "u-col-sm-12", "u-col-md-12", "u-col-lg-12", authCSS.confirmForm)}>
        <div className={classNames("u-flex u-flex-column", authCSS.confirmDropdown)}>
          <div className="u-flex u-flex-row u-col-lg-12 u-mb30px">
            <div className="u-flex u-flex-column u-col-lg-12 u-w100">
              <label htmlFor="dropdown" className="u-t-f14p u-ml10px">
                Ciljna skupina
              </label>
              <Dropdown
                items={TARGET_GROUPS.values}
                activeItemValue={selectedTargetGroup}
                defaultItem={null}
                placeholder={"odaberi"}
                removePlaceholder={true}
                handleChange={handleSelectChange}
                customCss={classNames("u-t-f16p u-mb0", formErrors.targetGroup ? authCSS.errorSelect : "")}
              />
              <p className="u-m0 u-t-f12p u-t-error">{formErrors.targetGroup}</p>
            </div>
          </div>
        </div>

        <div className={classNames("u-flex", "u-flex-content-center", "u-mb10px", "u-col-lg-12", authCSS.buttonWrap)}>
          <button
            type="submit"
            className={classNames(
              "u-bg-primary",
              "u-t-white",
              "u-cursor-pointer",
              "u-t-uppercase",
              "u-col-xs-12",
              "u-font-family-inh",
              "u-t-f16p",
              "u-t-lh24",
              authCSS.button
            )}
          >
            Spremi
          </button>
        </div>
      </form>
    </div>
  );
};

export default ConfirmTargetGroupForm;
